import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './sites.routes';

export class SitesController {
  newThing = '';

  /*@ngInject*/
  constructor($http, $scope, $location, Auth, Traduction) {
    var vm = this
    vm.isAdmin = Auth.isAdminSync;
    vm.orderBy = "client";
    vm.reverseSort = false;

    function fetchSites(){
      Auth.getCurrentUser().then(function(auth){
        if(Auth.isAdminSync()) {
          $http.get('/api/sites').then(response => {
            vm.sites = response.data;
          })
        } else {
          $http.get('/api/users/my/sites').then(response => {
            vm.sites = response.data.Sites;
          })
        }
      })
    }

    fetchSites();

    vm.editSite = function(site) {
      $location.path(`/site/${site._id}`)
    }

    vm.createSite = function() {
      $("#addSite").modal('show')
      vm.data = {}
    }

    vm.addSite = function(form){ 
      if(form.$valid) {
        vm.errors = {}
        $scope.clicked = true
        $http.patch(`/api/sites/${vm.data._id}`, vm.data).then(response => {
          fetchSites()
          $('#addSite').modal('hide')
          $scope.clicked = false
          vm.data = {}
        }).catch(err => {
          $http.post('/api/sites', vm.data).then(response => {
            fetchSites()
            $('#addSite').modal('hide')
            $scope.clicked = false
            vm.data = {}
          }).catch(err => {
            console.log(err)
            vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message}
            $scope.clicked = false
          });
        })
      }
    }

    vm.copySite = function(site) {
      vm.data = {}
      vm.siteToCopy = angular.copy(site)
      $('#copySite').modal('show')
    }

    vm.validateCopySite = function() {
      vm.siteToCopy.name = vm.data.name
      vm.siteToCopy._id = undefined
      console.log(vm.siteToCopy)
      $http.post('/api/sites/copy', vm.siteToCopy).then(function(){
        location.reload()
      })
    }

    vm.deleteSite = function(site) {
      $("#deleteSite").modal('show')
      vm.siteToDelete = site
    }

    vm.validateDelete = function() {
      $scope.clicked = true
      $http.delete(`/api/sites/${vm.siteToDelete._id}`).then(function(resp){
        fetchSites()
        $scope.clicked = false
        $("#deleteSite").modal('hide')
      });
    }
  }
}

export default angular.module('aperamApp.sites', [uiRouter])
  .config(routing)
  .component('sites', {
    template: require('./sites.html'),
    controller: SitesController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/sites/sites.component.js